import { HOME_QUERIES } from './query/Home';

export const HomeSchema = {
  queries: HOME_QUERIES,
};
